import React from 'react';
import { useRichText } from '../hooks';
import { commonFilter } from '../type';
import AiImg from '@op/assets/svg/icon-ai.svg';
import useLanguage from '@op/hooks/useLanguage';
import RichTextBlock from '@op/components/RichTextBlock';
import { SubmitValueType } from '@op/components/RichTextBlock/RichTextEditModal';

interface RichTextProps {
  filter: commonFilter | null;
}

export default function RichText({ filter }: RichTextProps) {
  const { formatMessage } = useLanguage();
  const { richText, modifyRichText, loading } = useRichText({
    filter,
  });

  return (
    <RichTextBlock
      tabs={richText}
      bodyStyle={{ marginBottom: '20px' }}
      tabsOptionStyle={{ margin: '10px 0px' }}
      isFull
      isEmpty={false}
      emptyHeight={148}
      loadingHeight={300}
      loading={loading}
      title={
        <div className="dbo-FeedbackAnalysis-title">
          <img className="dbo-FeedbackAnalysis-titleImg" src={AiImg} />
          {formatMessage('Core Overview')}
        </div>
      }
      onlyOneLanguage
      singleModel
      canEdit
      hasEmptyImg={false}
      emptyProps={{
        hasImg: false,
        hasTitle: false,
        contentCard: true,
      }}
      onConfirm={(_item: SubmitValueType) => {
        const promiseAll: Promise<Boolean>[] = [];
        const { start_time, end_time, date_type, ...remainingFilter } =
          filter || {};

        _item.map((item) => {
          const { key, text } = item || {};
          if (key) {
            promiseAll.push(
              modifyRichText({
                id: Number(key),
                summary: text,
                ...remainingFilter,
              }),
            );
          }
        });

        return Promise.all(promiseAll)
          .then(() => true)
          .catch((_e) => false);
      }}
    ></RichTextBlock>
  );
}
